module.exports = __webpack_public_path__ + "static/media/kofi.de22105e.webp";